import Vue from 'vue'

const state = {
  isActive: false
};

const mutations = {
  'ACTIVE_BG_LAYER' (state, bool) {
    state.isActive = bool;
  },
};

const actions = {
  changeBgLayer: ({commit}, bool) => {
    commit('ACTIVE_BG_LAYER', bool);
  }
};

const getters = {
  isBgLayerActive: state => {
    return state.isActive;
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/bgLayer.js